﻿window.replacetable = function (cu) {

    var instance = {
        widgetDidMount: function (state) {
            var filedsCollection = document.getElementsByClassName("decimalvtmask");
            for (var i = 0; i < filedsCollection.length; i++) {
                filedsCollection[i].onpaste = function (e) {
                    var valuetovalidate = getClipboardData(e).replace(".", ",");
                    validate_input_integrals.validatevt(e, valuetovalidate, state.root);
                };
                filedsCollection[i].onkeyup = function (e) {
                    var valuetovalidate = e.target.value.replace(".", ",");
                    validate_input_integrals.validatevt(e, valuetovalidate, state.root);
                };
            }

            // Для редактирования таможенного профиля
            filedsCollection = document.getElementsByClassName("decimaltpmask");
            for (var i = 0; i < filedsCollection.length; i++) {
                filedsCollection[i].onpaste = function (e) {
                    var valuetovalidate = getClipboardData(e).replace(",", ".").replace(" ", "");
                    validate_input_integrals.validatetp(e, valuetovalidate, state.root);
                };
                filedsCollection[i].onkeyup = function (e) {
                    var valuetovalidate = e.target.value.replace(",", ".").replace(" ", "");
                    validate_input_integrals.validatetp(e, valuetovalidate, state.root);
                };
            }
            ///

            var filedsCollection = document.getElementsByClassName("decimalkvmask");
            for (var i = 0; i < filedsCollection.length; i++) {
                filedsCollection[i].onpaste = function (e) {
                    var valuetovalidate = getClipboardData(e).replace(".", ",");
                    validate_input_integrals.validatekv(e, valuetovalidate, state.root);
                };
                filedsCollection[i].onkeyup = function (e) {
                    var valuetovalidate = e.target.value.replace(".", ",");
                    validate_input_integrals.validatekv(e, valuetovalidate, state.root);
                };
            }

            var filedsCollection = document.getElementsByClassName("decimalmvtmask");
            for (var i = 0; i < filedsCollection.length; i++) {
                filedsCollection[i].onpaste = function (e) {
                    const valuetovalidate = getClipboardData(e).replace(".", ",");
                    validate_input_integrals.validatemvt(e, valuetovalidate, state.root);
                };
                filedsCollection[i].onkeyup = function (e) {
                    var valuetovalidate = e.target.value.replace(".", ",");
                    validate_input_integrals.validatemvt(e, valuetovalidate, state.root);
                };
            }
        }
    }
    return instance;
}(commonUtils);

window.validate_input_integrals = function () {

    var instance = {
        validatevt: function (e, value, _id) {
            // var f = function (x) {
            //     return parseInt(x, 10) == 0 ? 0 : x % 1000;
            // }
            var ff = function (x) {
                return parseInt(x, 10) == 0 ? 0 : x.toString().indexOf(',');
            }
            var id = _id.replace("_data", "");

            if (_isNaN(value) && ff(value) <= 0) {
                enablebutton(id, e);
            }
            else {
                disablebutton(id, e);
            }

        },       
        validatekv: function (e, value, _id) {
            var f = function (x) {
                return ((x.toString().indexOf(',')) > -1 ? (x.toString().split(',').pop().length) : (0));
            }
            var id = _id.replace("_data", "");

            if (_isNaN(value) && f(value) <= 7) {
                enablebutton(id, e);
            }
            else {
                disablebutton(id, e);
            }

        },
        validatemvt: function (e, value, _id) {
            var f = function (x) {
                return ((x.toString().indexOf(',')) > -1 ? (x.toString().split(',').pop().length) : (0));
            }
            var id = _id.replace("_data", "");

            if (_isNaN(value) && f(value) <= 4) {
                enablebutton(id, e);
            }
            else {
                disablebutton(id, e);
            }
        }
    };

    function _isNaN(value) {
        return value == "" || !isNaN(parseInt(value, 10));
    }

    function disablebutton(id, e) {
        document.getElementById(id + "_savebtn").disabled = true;
        e.target.classList.add("line-through");
    }

    function enablebutton(id, e) {
        e.target.classList.remove("line-through");
        var isLockTI = document.getElementById(id + "_savebtn").hasAttribute("lockedti");
        if (document.getElementsByClassName("line-through").length == 0 && !isLockTI) {
            document.getElementById(id + "_savebtn").disabled = false;
        }
        e.target.classList.remove("line-through");
    }

    return instance;
}();